export const sssSorular = [
  {
    id: 1,
    soru: "Kampanya fiyatları ne kadar geçerli?",
    cevap: "Kampanya fiyatlarımız stoklarla sınırlıdır ve genellikle ay sonuna kadar geçerlidir. Ancak yoğun talep nedeniyle erken bitebilir. Size özel fiyatı garantilemek için hemen iletişime geçmenizi öneririz."
  },
  {
    id: 2,
    soru: "Uygulamalar acıtır mı?",
    cevap: "Tüm uygulamalarımızda konforunuz önceliğimizdir. Lazer epilasyonda soğutma sistemli cihazlar kullanıyoruz, cilt bakımlarında ise anestezik kremlerle ağrıyı minimuma indiriyoruz. Çoğu müşterimiz uygulamaları rahatlatıcı buluyor."
  },
  {
    id: 3,
    soru: "Kaç seans gerekli?",
    cevap: "Hizmete göre değişir: Lazer epilasyonda 6-8 seans öneriyoruz, Hydrafacial için aylık bakım yeterli, cilt yenileme paketlerinde ise 3-4 seanslık programlar uyguluyoruz. Ücretsiz cilt analiziyle size özel plan oluşturuyoruz."
  },
  {
    id: 4,
    soru: "Randevu almadan önce ne yapmam gerekir?",
    cevap: "Online formumuzu doldurmanız yeterli. Ekibimiz 15 dakika içinde sizi arayarak uygun tarih ve saati planlıyor. İlk ziyaretinizde ücretsiz cilt analizi ve uzman görüşü alıyorsunuz."
  },
  {
    id: 5,
    soru: "Ödeme seçenekleri neler?",
    cevap: "Nakit, kredi kartı ve taksitli ödeme imkanlarımız var. 6 aya varan taksit seçenekleriyle bütçenizi zorlamadan güzellik yolculuğunuza başlayabilirsiniz. Ayrıca paket alımlarında ek %10 indirim fırsatı sunuyoruz."
  },
  {
    id: 6,
    soru: "Sonuçlar ne zaman görünür?",
    cevap: "Birçok uygulamada ilk seanstan itibaren fark edilir değişim görürsünüz. Hydrafacial'da anında parlaklık, lazerde 2-3 seanstan sonra incelme, cilt yenilemede ise 2-4 haftada tam sonuç alırsınız."
  },
  {
    id: 7,
    soru: "Hamileler uygulama yaptırabilir mi?",
    cevap: "Hamilelikte Hydrafacial ve bazı cilt bakımları güvenle uygulanabilir. Ancak lazer epilasyon ve G5 sıkılaştırma gibi uygulamaları doğum sonrasına erteliyoruz. Detaylı bilgi için uzmanlarımıza danışabilirsiniz."
  },
  {
    id: 8,
    soru: "Kampanyaları birleştirebilir miyim?",
    cevap: "Kampanyalarımız genellikle tek kullanımlıktır, ancak paket alımlarında ek avantajlar sunuyoruz. Örneğin cilt bakımı + lazer epilasyon birlikte alındığında toplamda %15 ek indirim kazanırsınız. Size özel kombinasyon için arayın."
  }
];